module.exports = __webpack_public_path__ + "img/unlink1.b4897892.png";